import { Link } from 'react-router-dom';
import { FlaskConical, Radio } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { cn } from '../../lib/utils';

export const ModeBadge = () => {
  const { user } = useAuth();
  const live = user?.account_mode === 'live';
  const Icon = live ? Radio : FlaskConical;
  return (
    <Link
      to="/settings#environment"
      className={cn(
        'flex items-center gap-2 px-2 sm:px-3 py-1.5 rounded-full border transition-colors',
        live
          ? 'bg-emerald-500/10 border-emerald-500/20 text-emerald-400 hover:bg-emerald-500/20'
          : 'bg-amber-500/10 border-amber-500/30 text-amber-300 hover:bg-amber-500/20'
      )}
      title={live ? 'Live — syncing real data to your books' : 'Sandbox — demo data, safe to experiment'}
      data-testid="account-mode-badge"
    >
      <Icon className="w-3.5 h-3.5" />
      <span className="hidden sm:inline text-xs font-medium">{live ? 'Live' : 'Sandbox'}</span>
    </Link>
  );
};
